export default {
  langEnglish: 'Англійська',
  langRussian: 'Російська',
  langGerman: 'Німецька',
  langChinese: 'Китайська',
  langUkraine: 'Українська',
  changeLanguage: 'Змінити мову',
}


// WEBPACK FOOTER //
// ./src/locale/uk-UA/account.js